<script setup lang="ts">
import {computed} from "vue";
import {MultiSelect} from "@progress/kendo-vue-dropdowns";
import {useUxData} from "@/stores/ux-data";

const emit = defineEmits(['categorySelected'])
const props = defineProps<{
  placeholder: string | undefined,
  // Optional controlled selection (array of type aliases). When provided, the
  // widget is controlled and re-syncs on external changes (e.g. chip removal).
  // When omitted, the widget stays uncontrolled — existing consumers unaffected.
  selected?: string[],
}>()

const ux = useUxData();

const dataItems = computed(() =>
  (Object.getOwnPropertyNames(ux.labels.swade.data.equipment.types) ?? []).map((value: string) => ({
    label: ux.labels.swade.data.equipment.types[value ?? ''] ?? '',
    alias: value,
  }))
)

const valueBinding = computed(() =>
  props.selected === undefined
    ? {}
    : { value: dataItems.value.filter((item) => props.selected!.includes(item.alias)) }
)

const onChange = (event: any) => {
  emit('categorySelected', event);
}
</script>

<template>
  <MultiSelect
      text-field="label"
      data-item-key="alias"
      class="text-center p-0"
      :placeholder="placeholder"
      :data-items="dataItems"
      v-bind="valueBinding"
      @change="onChange($event)"
  />
</template>
